import { Music } from "@hg/media"

import gameBgm from "../assets/audio/game.mp3"
import intro from "../assets/audio/intro.mp3"
import loop from "../assets/audio/loop.mp3"

const introMusic = new Music({
    src: intro,
    loop: false,
    autoPlay: true,
    fade: false,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})

const loopMusic = new Music({
    src: loop,
    loop: true,
    autoPlay: false,
    fade: false,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})

let current: "intro" | "loop" = "intro"
introMusic.audioElem.addEventListener("ended", () => {
    current = "loop"
    loopMusic.enable()
})

export const music = {
    enable: () => {
        if (current === "intro") {
            introMusic.enable()
        } else {
            loopMusic.enable()
        }
    },
    disable: () => {
        introMusic.disable()
        loopMusic.disable()
    },
}

export const gameMusic = new Music({
    src: gameBgm,
    loop: true,
    autoPlay: false,
    fade: true,
    suspendWhenHidden: true,
    suspendWhenHiddenInSkland: true,
})
